import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import bridge from '@vkontakte/vk-bridge';

// Инициализируем мост асинхронно и логируем результат
const root = ReactDOM.createRoot(document.getElementById('root'));

const startApp = async () => {
  let initialAppearance = 'light';

  try {
    const initData = await bridge.send('VKWebAppInit');
    console.log('VK Bridge успешно инициализирован:', initData);

    const config = await bridge.send('VKWebAppGetConfig');
    initialAppearance = config?.appearance === 'dark' ? 'dark' : 'light';
  } catch (error) {
    console.error('Ошибка инициализации VK Bridge:', error);
  }

  document.documentElement.setAttribute('data-theme', initialAppearance);

  root.render(
    <React.StrictMode>
      <App initialAppearance={initialAppearance} />
    </React.StrictMode>
  );
};

startApp();

reportWebVitals();